import React from 'react';

/**
 * Generates the CSS mask image style for fading sides of the stream.
 * @param fadeSides - Whether to fade sides: true (both), 'left', 'right', or false/undefined (none)
 * @returns Style object with maskImage and WebkitMaskImage properties, or empty object if no fading
 */
export function getFadeSidesStyle(fadeSides?: boolean | 'left' | 'right'): React.CSSProperties {
  if (!fadeSides) {
    return {};
  }

  let maskImage: string;
  if (fadeSides === 'left') {
    maskImage = 'linear-gradient(to right, transparent -12px, black 12px)';
  } else if (fadeSides === 'right') {
    maskImage =
      'linear-gradient(to right, black 0%, black calc(100% - 12px), transparent calc(100% + 12px))';
  } else {
    // fadeSides === true, fade both sides
    maskImage =
      'linear-gradient(to right, transparent -12px, black 12px, black calc(100% - 12px), transparent calc(100% + 12px))';
  }

  return {
    maskImage,
    WebkitMaskImage: maskImage,
  };
}
